import { AuditUser } from "./auditUser"
import { Field, Template } from "."
import { CaseColumn } from "./caseColumns"

export interface Schedule {
    id?: string,
    tenantId: string;
    title: string;
	folder?: string | null;
    scheduleFreq: ScheduleFreq;
    dayOf?: number;
	date?: Date;
    startTime: any;
    endTime: any;
    templateId: string
    templateTitle: string
	timeZoneId: string
    fields: { [key: string]: any }
    fieldLabels: { [key: string]: any }
	minRunDate?: Date
	maxRunDate?: Date
	created?: Date
	createdByUser?: AuditUser
	lastUpdated?: Date
	lastUpdatedByUser?: AuditUser
	bulkCreateForTeams?: string[]
	bulkCreateUserRole?: string
	bulkCreateSubRole?: string
	status?: ScheduleStatus
}

export interface FolderSchedules {
	folderTitle: string
	expanded: boolean
	isFolderType: true
	schedules: Schedule[]
	allowRowClick: true
	onlyEmitOnRowClick: true
}

export interface ScheduleQueue {
    id?: string,
	schedule: Schedule,
	scheduleType: string,
	processAt: Date,
	processState: boolean,
	processBy: Date,
	createdAt: Date,
	createdBy: string
}

export enum ScheduleFreq {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
	Once = 4
}

export enum DayOfWeek {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday =0
}

export interface CalendarEvent {
	start: string | Date
	end: string | Date
	title: string
	hide?: boolean
}

const DayOfMonth = [
	{
		id: 1,
		title: "1"
	},
	{
		id: 2,
		title: "2"
	},
	{
		id: 3,
		title: "3"
	},
	{
		id: 4,
		title: "4"
	},
	{
		id: 5,
		title: "5"
	},
	{
		id: 6,
		title: "6"
	},
	{
		id: 7,
		title: "7"
	},
	{
		id: 8,
		title: "8"
	},
	{
		id: 9,
		title: "9"
	},
	{
		id: 10,
		title: "10"
	},
	{
		id: 11,
		title: "11"
	},
	{
		id: 12,
		title: "12"
	},
	{
		id: 13,
		title: "13"
	},
	{
		id: 14,
		title: "14"
	},
	{
		id: 15,
		title: "15"
	},
	{
		id: 16,
		title: "16"
	},
	{
		id: 17,
		title: "17"
	},
	{
		id: 18,
		title: "18"
	},
	{
		id: 19,
		title: "19"
	},
	{
		id: 20,
		title: "20"
	},
	{
		id: 21,
		title: "21"
	},
	{
		id: 22,
		title: "22"
	},
	{
		id: 23,
		title: "23"
	},
	{
		id: 24,
		title: "24"
	},
	{
		id: 25,
		title: "25"
	},
	{
		id: 26,
		title: "26"
	},
	{
		id: 27,
		title: "27"
	},
	{
		id: 28,
		title: "28"
	},
	{
		id: 29,
		title: "29"
	},
	{
		id: 30,
		title: "30"
	},
	{
		id: 31,
		title: "31"
	}
]

export { DayOfMonth }

export interface SortByOptions {
	columnKey: string,
	descending: "asc" | "desc"
}

export enum ScheduleStatus {
	Open = 1,
	Upcoming = 2,
	Closed = 3
}
